import { ArrowDropDown } from "@mui/icons-material";
import {
  Button,
  ButtonGroup,
  ButtonGroupProps,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { useRef, useState } from "react";

interface Option<T> {
  title: string;
  value: T;
  header?: boolean;
}

type DropdownButtonProps<T> = Omit<ButtonGroupProps, "onSelect"> & {
  title: string;
  options: Option<T>[];
  onSelect: (value: T) => void;
};

export function DropdownButton<T>({ title, options, onSelect, ...props }: DropdownButtonProps<T>) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const handleMenuItemClick = (value: T) => {
    onSelect(value);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <ButtonGroup {...props} ref={anchorRef}>
        <Button onClick={handleToggle}>{title}</Button>
        <Button size="small" onClick={handleToggle}>
          <ArrowDropDown />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom" ? "center top" : "center bottom",
            }}>
            <Paper sx={{ maxHeight: 400, overflowY: "auto" }}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option) => {
                    return !option.header ? (
                      <MenuItem key={option.title} onClick={() => handleMenuItemClick(option.value)}>
                        {option.title}
                      </MenuItem>
                    ) : (
                      <MenuItem key={option.title} divider>
                        {option.title}
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}
